import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import SelectLanguage from '../select/SelectLanguage';
import FieldHoc from './FieldHoc';

const SelectLanguageField = ({ input, meta, placeholder, className, options }) => {
    return (
        <SelectLanguage
            {...input}
            selectedItem={input.value}
            placeholder={placeholder || input.name}
            inputClassName={cx(className, {
                // TODO: supporto touch???
                'is-error': meta.error && meta.touched
            })}
        />
    );
};

SelectLanguageField.propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string
};

SelectLanguageField.defaultProps = {
    className: 'form-input'
};

export default FieldHoc(SelectLanguageField);
